import React from "react";
import "./Button.css";

function Button({ onClick, children, className, type = "button", disabled, title }) {
  return (
    <button className={className} onClick={onClick} type={type} disabled={disabled} title={title}>
      <span>{children}</span>
    </button>
  );
}

export default Button;



// WEBPACK FOOTER //
// ./src/common/button/Button.js